// extracted by mini-css-extract-plugin
var _1 = "_customerManagementCreateCollateralForm-module__available-balance";
var _2 = "_customerManagementCreateCollateralForm-module__button-container";
var _3 = "_customerManagementCreateCollateralForm-module__button-subcontainer";
var _4 = "_customerManagementCreateCollateralForm-module__container";
var _5 = "_customerManagementCreateCollateralForm-module__filter-container";
var _6 = "_customerManagementCreateCollateralForm-module__flex-div";
var _7 = "_customerManagementCreateCollateralForm-module__form-container";
var _8 = "_customerManagementCreateCollateralForm-module__joint-account-details-container";
var _9 = "_customerManagementCreateCollateralForm-module__span-2";
var _a = "_customerManagementCreateCollateralForm-module__use-api-container";
export { _1 as "available-balance", _2 as "button-container", _3 as "button-subcontainer", _4 as "container", _5 as "filter-container", _6 as "flex-div", _7 as "form-container", _8 as "joint-account-details-container", _9 as "span-2", _a as "use-api-container" }
